// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.legal-page-shell {
  --legal-content-inset: clamp(1.15rem, 4.2vw, 2rem);
  --legal-nav-height: 5.25rem;
  --legal-footer-height: 40px;
  width: 100%;
  /* 👇 MAIN FIX */
  min-height: calc(100vh - var(--legal-footer-height));
  padding-top: calc(var(--legal-nav-height) + var(--legal-content-inset));
  padding-right: var(--legal-content-inset);
  padding-left: var(--legal-content-inset);
  /* 👇 IMPORTANT */
  padding-bottom: var(--legal-footer-height);
}

.legal-page {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0;
  color: #e2e8f0;
  font-family: "Orbitron", sans-serif;
  line-height: 1.2;
}

@media (max-width: 1440px) {
  .legal-page {
    max-width: 1100px;
  }
}
@media (max-width: 1024px) {
  .legal-page {
    max-width: 900px;
  }
}
@media (max-width: 768px) {
  .legal-page {
    line-height: 1.3;
  }
}
.legal-page__title {
  color: #fff;
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: 700;
  margin: 0 0 0.75rem;
  letter-spacing: 0.02em;
}

.legal-page__effective {
  color: #94a3b8;
  font-size: 0.9rem;
  margin: 0 0 1.5rem;
}

.legal-page__section {
  margin-top: 1.75rem;
}
.legal-page__section:first-of-type {
  margin-top: 0.5rem;
}

.legal-page__heading {
  color: #f1f5f9;
  font-size: clamp(1.1rem, 2.5vw, 1.35rem);
  font-weight: 600;
  margin: 0 0 0.65rem;
  letter-spacing: 0.03em;
}

.legal-page__text {
  margin: 0 0 0.85rem;
  color: #cbd5e1;
  font-size: 0.95rem;
}
.legal-page__text:last-child {
  margin-bottom: 0;
}

.legal-page__list {
  margin: 0.5rem 0 1rem;
  padding-left: 1.35rem;
  color: #cbd5e1;
  font-size: 0.95rem;
}
.legal-page__list li {
  margin-bottom: 0.45rem;
}

.legal-page__note {
  background: rgba(87, 72, 119, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 0.9rem 1rem;
  margin: 1.25rem 0;
  font-size: 0.9rem;
  color: #cbd5e1;
}

.legal-page__link {
  color: #7dd3fc;
  text-decoration: none;
  transition: color 0.2s ease, opacity 0.2s ease;
}
.legal-page__link:hover {
  color: #bae6fd;
  text-decoration: underline;
}

.legal-page__back {
  display: inline-block;
  margin-bottom: 1rem;
  color: #c4b5fd;
  font-size: 0.85rem;
  text-decoration: none;
}

.legal-page__back:hover {
  color: #ffffff;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/LegalPage.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kDAAA;EACA,2BAAA;EACA,2BAAA;EAEA,WAAA;EAEA,gBAAA;EACA,oDAAA;EAEA,uEAAA;EACA,yCAAA;EACA,wCAAA;EAEA,iBAAA;EACA,0CAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;AAFF;;AAKA;EACE;IACE,iBAAA;EAFF;AACF;AAKA;EACE;IACE,gBAAA;EAHF;AACF;AAMA;EACE;IACE,gBAAA;EAJF;AACF;AAOA;EACE,WAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AALF;;AAQA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AALF;;AAQA;EACE,mBAAA;AALF;AAOE;EACE,kBAAA;AALJ;;AASA;EACE,cAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AANF;AAQE;EACE,gBAAA;AANJ;;AAUA;EACE,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAPF;AASE;EACE,sBAAA;AAPJ;;AAWA;EACE,mCAAA;EACA,2CAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AARF;;AAWA;EACE,cAAA;EACA,qBAAA;EACA,8CAAA;AARF;AAUE;EACE,cAAA;EACA,0BAAA;AARJ;;AAYA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AATF;;AAYA;EACE,cAAA;EACA,0BAAA;AATF","sourcesContent":[".legal-page-shell {\n  --legal-content-inset: clamp(1.15rem, 4.2vw, 2rem);\n  --legal-nav-height: 5.25rem;\n  --legal-footer-height: 40px;\n\n  width: 100%;\n\n  /* 👇 MAIN FIX */\n  min-height: calc(100vh - var(--legal-footer-height));\n\n  padding-top: calc(var(--legal-nav-height) + var(--legal-content-inset));\n  padding-right: var(--legal-content-inset);\n  padding-left: var(--legal-content-inset);\n\n  /* 👇 IMPORTANT */\n  padding-bottom: var(--legal-footer-height);\n}\n\n.legal-page {\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0;\n  color: #e2e8f0;\n  font-family: \"Orbitron\", sans-serif;\n  line-height: 1.2;\n}\n\n@media (max-width: 1440px) {\n  .legal-page {\n    max-width: 1100px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .legal-page {\n    max-width: 900px;\n  }\n}\n\n@media (max-width: 768px) {\n  .legal-page {\n    line-height: 1.3;\n  }\n}\n\n.legal-page__title {\n  color: #fff;\n  font-size: clamp(1.5rem, 4vw, 2rem);\n  font-weight: 700;\n  margin: 0 0 0.75rem;\n  letter-spacing: 0.02em;\n}\n\n.legal-page__effective {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  margin: 0 0 1.5rem;\n}\n\n.legal-page__section {\n  margin-top: 1.75rem;\n\n  &:first-of-type {\n    margin-top: 0.5rem;\n  }\n}\n\n.legal-page__heading {\n  color: #f1f5f9;\n  font-size: clamp(1.1rem, 2.5vw, 1.35rem);\n  font-weight: 600;\n  margin: 0 0 0.65rem;\n  letter-spacing: 0.03em;\n}\n\n.legal-page__text {\n  margin: 0 0 0.85rem;\n  color: #cbd5e1;\n  font-size: 0.95rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.legal-page__list {\n  margin: 0.5rem 0 1rem;\n  padding-left: 1.35rem;\n  color: #cbd5e1;\n  font-size: 0.95rem;\n\n  li {\n    margin-bottom: 0.45rem;\n  }\n}\n\n.legal-page__note {\n  background: rgba(87, 72, 119, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  padding: 0.9rem 1rem;\n  margin: 1.25rem 0;\n  font-size: 0.9rem;\n  color: #cbd5e1;\n}\n\n.legal-page__link {\n  color: #7dd3fc;\n  text-decoration: none;\n  transition: color 0.2s ease, opacity 0.2s ease;\n\n  &:hover {\n    color: #bae6fd;\n    text-decoration: underline;\n  }\n}\n\n.legal-page__back {\n  display: inline-block;\n  margin-bottom: 1rem;\n  color: #c4b5fd;\n  font-size: 0.85rem;\n  text-decoration: none;\n}\n\n.legal-page__back:hover {\n  color: #ffffff;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
